import React from 'react';
import PropTypes from 'prop-types';
import Icon from 'components/Icon';
import {CERTIFICATION_STATES} from 'app/CardConstants';
import styles from './CardCertification.css?module';
import cx from 'classnames';
import get from 'lodash/get';

const getCertificationState = card => get(card, ['certification', 'state']);

export const CardCertification = ({card, className}) => {
  const certificationState = getCertificationState(card);
  if (!CERTIFICATION_STATES.includes(certificationState)) return null;

  return (
    <Icon
      className={cx(styles[certificationState.toLowerCase()], className)}
      icon={Icon.OPTIONS.CERTIFIED}
      size={Icon.SIZES.NANO}
    />
  );
};

CardCertification.propTypes = {
  card: PropTypes.object,
};

export default CardCertification;
